import { createInertiaApp, router } from "@inertiajs/react"
import axios from "axios"
import posthog from "posthog-js"
import { createElement, ReactNode } from "react"
import { createRoot } from "react-dom/client"
import { LazyMotion, domAnimation } from "motion/react"

// PostHog — production only
if (window.location.hostname === "cryptoemailalerts.com") {
  posthog.init("phc_aEzdRHNQi6oegcSaxqQhb83G8mwYSKASZs0QxbkNhdp", {
    api_host: "/ph",
    ui_host: "https://eu.posthog.com",
    capture_pageview: false, // We handle this via Inertia router
    capture_pageleave: true,
    persistence: "localStorage",
  })

  router.on("navigate", () => {
    posthog.capture("$pageview", { $current_url: window.location.href })
  })
}

// Temporary type definition, until @inertiajs/react provides one
type ResolvedComponent = {
  default: ReactNode
  layout?: (page: ReactNode) => ReactNode
}

createInertiaApp({
  title: (title) =>
    `${title || "Monitor your crypto prices"} - CryptoEmailAlerts`,
  resolve: (name) => {
    const pages = import.meta.glob<ResolvedComponent>("../pages/**/*.tsx", {
      eager: true,
    })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`)
    }

    return page
  },

  progress: {
    delay: 250,
    color: "var(--color-teal-500)",
    includeCSS: true,
    showSpinner: false,
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(
        <LazyMotion features={domAnimation} strict>
          {createElement(App, props)}
        </LazyMotion>
      )
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.'
      )
    }
  },
})

const csrfToken = (
  document.querySelector("meta[name=csrf-token]") as HTMLMetaElement
).content
axios.defaults.headers.common["X-CSRF-Token"] = csrfToken
